module.exports = __webpack_public_path__ + "img/06_k_mov.91edbf8d.webp";